module.exports = __webpack_public_path__ + "images/advanced.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/advanced.png
// module id = 2TqX
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15